
    export default {
        name: 'SocialNetworksTab',
        computed: {
            basicData() {
                return this.$store.state.basicData;
            },
        },
    };
